export const PROTOCOL = process?.env?.["NEXT_PUBLIC_PROTOCOL"] as string;

export const OWN_HOST = process?.env?.["NEXT_PUBLIC_OWN_HOST"] as string;

// For links and fetch requests, you can specify URLs with a leading slash and
// the origin will be implicitly added. In such cases you do not need to use
// `OWN_ORIGIN`. `OWN_ORIGIN` is available for other use cases, like
// contructing a URL to be used by other services. For example a return URL
// when linking out to a different service.
export const OWN_ORIGIN = `${PROTOCOL}://${OWN_HOST}`;

export const LOW_NAV_Z_INDEX = 14 as const;
export const HIGH_NAV_Z_INDEX = 15 as const;

export const GLOBAL_NAV_Z_INDEX = 10 as const;

export const TOASTER_Z_INDEX = 200 as const;

/**
 * IMPORTANT: this is the list of URLs using the new USER API, once an url is added here, it will enable the new API USAGE at:
 *
 * /middleware.ts - And will skip all interceptors
 * /users/useUser.js hook will be replaced by /users/useFutureUser.tsx hook
 * /users/getUserProperties will ber replaced by the new one at /users/getFutureUserProperties
 *
 * Use with caution !!!
 * The new API doesn't returns compatible data, so each addeded page needs to be transformed and well tested as well.
 * More info: https://newsela.atlassian.net/wiki/spaces/UM/pages/3698491658/Redesign+v3+User#Ways-to-get-the-removed-data
 */
export const PAGES_USING_NEW_USER_API = ["/admin/api-tool-demo", "/signin"];
